import styled from '@emotion/styled'
import { Card, CardContent, Typography } from '@mui/material'

export const ModuleWrapper = styled(Card)({
  borderRadius: '8px',
  marginBottom: '16px',
  backgroundColor: '0px 2px 6px -1px rgba(0,0,0,0.5)',
})

export const ModuleItem = styled(CardContent)({
  padding: '1rem !important',
})

export const ModuleHeader = styled(Typography)({
  fontWeight: 700,
  color: '#193766',
  display: 'flex',
  alignItems: 'center',
  marginBottom: '24px',
})

export const ModuleDescription = styled(Typography)({
  wordBreak: 'break-word',
  position: 'relative',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  textAlign: 'justify',
  color: '#193766',
})
